/**
 * InventoryNav — thin sub-navigation shell mounted at /inventory.
 *
 * Inventory is the sole top-level Ops nav item (see Layout.jsx); Recipes is
 * reachable only through this internal "Inventory | Recipes" tab strip, and
 * the legacy top-level /baking path redirects here (see App.js). No
 * SensitivePageGate is added — Recipes was not gated before this move and
 * this relocation does not change that.
 */
import SectionNav from "@/components/SectionNav";
import { prefetchRecipes } from "@/features/recipes/recipesQueryClient";
import { Outlet } from "react-router-dom";

function prefetchRecipesChunk() {
  void import("@/features/recipes/BakingV2Root");
}

function warmRecipes() {
  prefetchRecipesChunk();
  void prefetchRecipes();
}

const TABS = [
  { to: "/inventory", label: "Inventory", end: true },
  {
    to: "/inventory/recipes",
    label: "Recipes",
    end: false,
    onHover: warmRecipes,
  },
];

export default function InventoryNav() {
  return (
    <div data-testid="inventory-nav">
      <SectionNav tabs={TABS} ariaLabel="Inventory sections" testIdPrefix="inventory" />
      <Outlet />
    </div>
  );
}
